import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

/**
 * True when the current staff session belongs to a *tenant operator* rather
 * than an agency agent.
 *
 * Both arrive in B2C the same way — BO opens the site with `?t=<jwt>` and
 * `useLoadAgentUser` exchanges it at `POST /supplier/site/agentInfo`. The
 * difference is decided server-side: a user with no `tbl_agent_users` row gets
 * `is_operator: true` and `agency: null` back (SiteController::actionAgentInfo).
 *
 * Operators run with `agentMode: true`, so they keep the staff behaviours
 * (membership-wall bypass, relaxed checkout validation, create-order). What
 * they do NOT get is anything agency-shaped: sky360-ms only serves net prices
 * and `agent_additional_info` to tokens carrying agent_id/agency_id
 * (PermissionService.isAgentUser), so operators always see public gross prices
 * and there is no commission to show, split or edit.
 *
 * Use this to hide commission/net-price surfaces — never to decide whether the
 * visitor is staff at all; that is still `agentInfo.agentMode`.
 */
export const useIsOperator = (): boolean =>
  useSelector((state: RootState) => !!state.config.agentInfo?.is_operator);

export default useIsOperator;
